import { applyAuth0Theme } from "@/utils/theme";

import ResetPasswordRequestForm from "./components/ResetPasswordRequestForm";
import { useResetPasswordRequestManager } from "./hooks/resetPasswordRequestManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function ResetPasswordRequestScreen() {
    // Extracting attributes from hook made out of ResetPasswordRequestInstance class of Auth0 React SDK
    const { resetPasswordRequest, texts, locales } =
        useResetPasswordRequestManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(resetPasswordRequest);
    // Use locale strings with fallback to SDK texts
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <ResetPasswordRequestForm />
            </AuthLayout>
    );
}

export default ResetPasswordRequestScreen;
